import { render, staticRenderFns } from "./list-scrollbar.vue?vue&type=template&id=62926474&scoped=true&"
import script from "./list-scrollbar.vue?vue&type=script&lang=js&"
export * from "./list-scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./list-scrollbar.vue?vue&type=style&index=0&id=62926474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62926474",
  null
  
)

export default component.exports